"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestTelemetryExporter = void 0;
/**
 * TestTelemetryExporter does nothing with exported events but record them
 * for retrieval with (TestTelemetryExporter).getExported().
 */
class TestTelemetryExporter {
    constructor() {
        this.events = [];
    }
    exportEvents(events) {
        this.events.push(...events);
        return Promise.resolve();
    }
    /**
     * Retrieve all events that have been "exported" so far.
     */
    getExported() {
        return this.events;
    }
}
exports.TestTelemetryExporter = TestTelemetryExporter;
//# sourceMappingURL=testing.js.map